import { Modal, Center, Loader, Text } from '@mantine/core';

interface LoadingModalProps {
  opened: boolean;
  title?: string;
  message?: string;
}

const LoadingModal = ({ opened, title = 'Loading...', message }: LoadingModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={() => {}}
      closeOnClickOutside={false}
      withCloseButton={false}
      centered
      title={title}
      // withOverlay={false}
      transitionProps={{ duration: 200, transition: 'fade-up' }}
    >
      <Center style={{ flexDirection: 'column', gap: 12, padding: 20 }}>
        <Loader size="lg" />
        {message && <Text>{message}</Text>}
      </Center>
    </Modal>
  );
};

export default LoadingModal;
